import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionUtils } from '@yupma/ui-kit';
import { Subscription } from 'rxjs';
import { ActivityDefinitionDocument, ActivityType, EntityAddFormDocument, EntityAddFormField, EntityType, FieldDocument, UserDocument } from 'server-model';
import { CRMActivityDataService, CRMActivityDefintionDataService, CRMFieldDataService, EntityConfigurationDataService, IAMService, OrganisationDataService, UIService } from 'src/app/services/services.module';
import { AddActivityModalOptions } from 'src/app/services/ui/ui.service';

@Component({
  selector: 'app-global-overlays',
  templateUrl: './global-overlays.component.html',
  styleUrl: './global-overlays.component.scss'
})
export class GlobalOverlaysComponent implements OnInit, OnDestroy {
  isAddContactDrawerOpen: boolean = false;
  isAddActivityModalOpen: boolean = false;
  allFields: FieldDocument[] = [];
  entityAddFormFields: EntityAddFormField[] = [];
  allUsers: UserDocument[] = [];
  allActivityDefinitions: ActivityDefinitionDocument[] = [];
  currentActivityType: ActivityType | string = ActivityType.NOTE;
  entityType: EntityType | null = null;
  entityId: string = '';
  isLog: boolean = false;

  private addContactDrawerSubscription: Subscription = new Subscription;
  private addActivityModalSubscription: Subscription = new Subscription;


  constructor(
    private iamService: IAMService,
    private uiService: UIService,
    private crmFieldDataService: CRMFieldDataService,
    private entityConfigurationDataService: EntityConfigurationDataService,
    private organisationDataService: OrganisationDataService,
    private crmActivityDefintionDataService: CRMActivityDefintionDataService,
  ) {
  }

  ngOnDestroy() {
    SubscriptionUtils.unsubscribe(this.addContactDrawerSubscription);
    SubscriptionUtils.unsubscribe(this.addActivityModalSubscription);
  }

  async ngOnInit() {
    await this.init()
    await this.initContactDrawer()
    await this.initActivityModal()
    this.subscribeObservables();
  }

  private async init() {
    try {
      const organisationId = this.iamService.getOrganisationId();
      this.allUsers = (await this.organisationDataService.listOrganisationUsers(organisationId)).data;
    } catch (error) {
      console.log(error)
    }
  }

  private async initContactDrawer() {
    try {
      const organisationId = this.iamService.getOrganisationId();
      this.allFields = (await this.crmFieldDataService.listFields(organisationId)).data;
      let entityAddForm = (await this.entityConfigurationDataService.getEntityAddForm(organisationId, EntityType.CONTACT)).data;
      this.entityAddFormFields = entityAddForm.fields;
    } catch (error) {
      console.log(error)
    }
  }

  private async initActivityModal() {
    try {
      const organisationId = this.iamService.getOrganisationId();
      this.allActivityDefinitions = (await this.crmActivityDefintionDataService.listActivityDefinition(organisationId)).data;
    } catch (error) {
      console.log(error)
    }
  }

  private subscribeObservables() {
    this.addContactDrawerSubscription = this.uiService.onAddContactDrawerStateChangedEvent$.subscribe((value) => {
      this.isAddContactDrawerOpen = value;
      if (value === true) {
        this.init();
        this.initContactDrawer();
      }
    })
    this.addActivityModalSubscription = this.uiService.onAddActivityModalStateChangedEvent$.subscribe((value: AddActivityModalOptions) => {
      this.isAddActivityModalOpen = value.state;
      if (value.state === true) {
        this.currentActivityType = value.activityType;
        this.entityType = value.entityType;
        this.entityId = value.entityId;
        this.isLog = value.isLog;
        this.init();
        this.initActivityModal();
      }
    })
  }
}
